<template>
  <div class="search-pane">
    <van-search
      ref="search"
      v-model="value"
      show-action
      placeholder="输入期货品种名称"
      @input="onQuery"
      @cancel="onCancel" />
    <div class="desc">搜索结果</div>
    <van-cell-group v-show="!empty">
      <van-cell :key="item.future_code" v-for="item in commodityList" :title="item.commodity_name" title-class="cell-title" @click="onPush(item)"/>
    </van-cell-group>
    <div v-show="!empty && !loading" class="hint-pane">到底啦</div>
    <div v-show="!emptyInput" class="hint">
      <span v-show="empty && !loading">没有找到相关内容</span>
      <van-loading v-show="loading === 1" size="24px">搜索中...</van-loading>
      <span v-show="loading === -1" @click="onQuery">加载失败，请点击<span class="emphasis">重试</span></span>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { Search, Cell, CellGroup, Loading } from 'vant'
export default {
  name: 'SearchPane',
  components: {
    [Search.name]: Search,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Loading.name]: Loading,
  },
  data(){
    return {
      value: '',
      commodityList: [],
      loading: 1, // 1: 加载中 0：加载完成 -1：加载失败
      emptyInput: true
    }
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      vm.value = ''
      vm.commodityList = []
      setTimeout(() => {
        vm.$refs.search.querySelector('input').focus()
      }, 0);
    })
  },
  created() {
    this.onQuery = this.debounce(this.fuzzyCommodity, 500)
  },
  methods: {
    debounce(fn, wait){
      let timmer = null;
      return function() {
        if(timmer){
          clearTimeout(timmer)
        }
        timmer = setTimeout(() => {
          fn();
        }, wait);
      }
    },
    async fuzzyCommodity(){
      if(this.value){
        let res;
        this.loading = 1;
        try{
          this.emptyInput = false;
          res = await api.fuzzyCommodity(this.value)
          console.log('模糊查询商品数据', res);
          this.commodityList = res;
          this.loading = 0;
        }catch(err){
          this.loading = -1;
          console.error('模糊查询商品数据加载失败', err);
        }
      }
    },
    onPush(data){
      this.$router.replace({
        name: 'main',
        params: {
          searchData: {
            category: {
              plate_name: data.plate_name
            },
            commodity: {
              future_code: data.future_code,
              commodity_name: data.commodity_name
            }
          }
        }
      })
    },
    onCancel(){
      this.$router.back()
    }
  },
  computed: {
    empty(){
      return this.commodityList.length === 0
    },
  },
  watch:{
    value(val){
      if(!val){
        this.emptyInput = true
        this.commodityList = []
      }
    }
  }
}
</script>
<style scoped>
.search-pane{
  background-color: #fff;
  margin-bottom: .3rem;
}
.search-pane .desc{
  color: #9A9A9A;
  padding: .12rem .15rem;
}
.search-pane .cell-title{
  font-size: .14rem;
  color: #2C2C2C;
}
.search-pane .hint{
  color: #9A9A9A;
  padding-top: .3rem;
  text-align: center;
  background-color: #F7F9FC;
}
.search-pane .hint .emphasis{
  color: #1461F3;
  text-decoration: underline;
}
input{
  /* -webkit-user-select：text */
  user-select: text
}
</style>